module.exports = __webpack_public_path__ + "media/images/icons/icon_video_black-fdd57942cffa2386bcf02e88b5beed43.svg";